import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=c6b15164&"
import script from "./ProfileInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports